import type { UbaPatient } from './queries'
import type { UbaProduct } from './types'

import { useCallback, useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import { useParams } from 'react-router'
import { useNavigate } from 'react-router-dom'

import http from '../../lib/http'
import { LoadingIndicator } from '../claim-history/simple-table/loading-indicator'
import * as Card from '../shared/card'

import { CreateOrderForm } from './components/create-order-form'
import { OrderTotal } from './components/order-total'
import { UbaOrdersList } from './components/orders-list'
import { UbaUser } from './components/uba-user'

export interface UbaPatientData {
  ubaUser: boolean
  data: UbaPatient
}

export function Uba (): JSX.Element {
  const params = useParams<{ id: string, clientName: string }>()
  const navigate = useNavigate()
  const [ products, setProducts ] = useState<Array<UbaProduct & { quantity: number }>>([])
  const [ state, setState ] = useState<UbaPatientData>()

  const fetchUser = useCallback(async (id: string): Promise<void> => {
    let response = await http.getRequest<UbaPatientData>(`/uba/${id}/info`, {})

    if (!response.ubaUser) {
      navigate(`/patient/${params?.clientName ?? ''}/${params?.id ?? ''}/assessment/uba/new-user`)
      return
    }

    setState(response)
  }, [ navigate, params?.clientName, params?.id ])

  useEffect(() => {
    fetchUser(params.id ?? '')
      .catch(() => {
        toast.error("Something went wrong while fetching user's data")
      })
  }, [ fetchUser, params.id ])

  if (!state) {
    return (
      <LoadingIndicator loading />
    )
  }

  function cleanUp (): void {
    setProducts([])
  }

  return (
    <div>
      {state.data && (

        <div className='flex flex-col gap-4'>
          <UbaUser state={state.data} />

          <Card.Card expandable>
            <Card.Header>
              Orders
            </Card.Header>
            <Card.ExpandableWrapper>
              <UbaOrdersList />
            </Card.ExpandableWrapper>
          </Card.Card>

          <div className='grid grid-cols-[auto,330px] gap-4'>
            <Card.Card>
              <Card.Header>
                Find Medication
              </Card.Header>
              <Card.ExpandableWrapper>
                <CreateOrderForm
                  products={products}
                  setProducts={setProducts}
                />
              </Card.ExpandableWrapper>
            </Card.Card>
            <OrderTotal
              patientGUID={state.data.patientGUID}
              products={products}
              cleanUp={cleanUp}
            />
          </div>

        </div>
      )}
    </div>
  )
}
